module.exports = __webpack_public_path__ + "img/yml.c8cbc6e4.jpeg";